{
  "name": "kaleido-compass",
  "doc": "A rotation whose sign flips with the radius (rot and rotr opposed): the centre turns one way, the rim the other, and the MIRROR wave makes it symmetric - a compass rose that keeps re-forming.",
  "cx": 0.5,
  "cy": 0.5,
  "zoom": 1.01,
  "zoomexp": 1.0,
  "rot": 0.016,
  "rotr": -0.05,
  "dx": 0,
  "dy": 0,
  "sx": 1,
  "sy": 1,
  "warp": 0,
  "warpScale": 4,
  "warpSpeed": 0.3,
  "decay": 0.96,
  "invert": 0,
  "hueShift": 0.003,
  "darkenCenter": 0.3,
  "wave": "MIRROR",
  "waveColor": 0,
  "shapes": 2,
  "energy": [
    0.45,
    0.9
  ]
}